/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  LearningCenterOptionsCycles,
  LearningCenterOptionsCyclesFromJSON,
  LearningCenterOptionsCyclesToJSON,
} from './'

/**
 * All categories and filetypes that are available for a program type.
 * @export
 * @interface LearningCenterOptions
 */
export interface LearningCenterOptions {
  /**
   * All of the categories (strands) that learning center content can have.
   * @type {Array<string>}
   * @memberof LearningCenterOptions
   */
  categories: Array<string>
  /**
   * All the filetypes that learning center content can be.
   * @type {Array<string>}
   * @memberof LearningCenterOptions
   */
  filetypes: Array<string>
  /**
   * All the programs with content the current user has access.
   * @type {Array<string>}
   * @memberof LearningCenterOptions
   */
  programTypes?: Array<string>
  /**
   * A list of cycles available to the user in a specific region.
   * @type {Array<LearningCenterOptionsCycles>}
   * @memberof LearningCenterOptions
   */
  cycles?: Array<LearningCenterOptionsCycles>
}

export function LearningCenterOptionsFromJSON(
  json: any
): LearningCenterOptions {
  return LearningCenterOptionsFromJSONTyped(json, false)
}

export function LearningCenterOptionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LearningCenterOptions {
  if (json === undefined || json === null) {
    return json
  }
  return {
    categories: json['categories'],
    filetypes: json['filetypes'],
    programTypes: !exists(json, 'programTypes')
      ? undefined
      : json['programTypes'],
    cycles: !exists(json, 'cycles')
      ? undefined
      : (json['cycles'] as Array<any>).map(LearningCenterOptionsCyclesFromJSON),
  }
}

export function LearningCenterOptionsToJSON(
  value?: LearningCenterOptions | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    categories: value.categories,
    filetypes: value.filetypes,
    programTypes: value.programTypes,
    cycles:
      value.cycles === undefined
        ? undefined
        : (value.cycles as Array<any>).map(LearningCenterOptionsCyclesToJSON),
  }
}
